<template>
  <el-dialog
    title="支持交易对"
    :visible.sync="dialogVisible"
    width="800"
    @close="closeDialogVisible"
  >
    <h2 class="subtitle">BKK</h2>
    <el-checkbox
      class="item-one"
      :indeterminate="BKK.isIndeterminate"
      v-model="BKK.checkAll"
      @change="
        (e) => {
          handleCheckAllChange(e, 'BKK');
        }
      "
      >全选</el-checkbox
    >
    <div style="margin: 10px 0"></div>
    <el-checkbox-group
      v-model="BKK.list"
      class="checkboxGroup"
      @change="handleCheckedCitiesChange"
    >
      <el-checkbox
        v-for="(item, index) in pairMap.BKK"
        :key="index"
        :label="item.pair"
        class="item-one"
        :disabled="item.isOther"
        >{{ item.pair }}</el-checkbox
      >
    </el-checkbox-group>
    <h2 class="subtitle">BTC</h2>
    <el-checkbox
      class="item-one"
      :indeterminate="BTC.isIndeterminate"
      v-model="BTC.checkAll"
      @change="
        (e) => {
          handleCheckAllChange(e, 'BTC');
        }
      "
      >全选</el-checkbox
    >
    <div style="margin: 10px 0"></div>
    <el-checkbox-group
      v-model="BTC.list"
      class="checkboxGroup"
      @change="handleCheckedCitiesChange"
    >
      <el-checkbox
        v-for="(item, index) in pairMap.BTC"
        :key="index"
        :label="item.pair"
        class="item-one"
        :disabled="item.isOther"
        >{{ item.pair }}</el-checkbox
      >
    </el-checkbox-group>
    <h2 class="subtitle">ETH</h2>
    <el-checkbox
      class="item-one"
      :indeterminate="ETH.isIndeterminate"
      v-model="ETH.checkAll"
      @change="
        (e) => {
          handleCheckAllChange(e, 'ETH');
        }
      "
      >全选</el-checkbox
    >
    <div style="margin: 10px 0"></div>
    <el-checkbox-group
      v-model="ETH.list"
      class="checkboxGroup"
      @change="handleCheckedCitiesChange"
    >
      <el-checkbox
        v-for="(item, index) in pairMap.ETH"
        :key="index"
        :label="item.pair"
        class="item-one"
        :disabled="item.isOther"
        >{{ item.pair }}</el-checkbox
      >
    </el-checkbox-group>
    <h2 class="subtitle">MOON</h2>
    <el-checkbox
      class="item-one"
      :indeterminate="MOON.isIndeterminate"
      v-model="MOON.checkAll"
      @change="
        (e) => {
          handleCheckAllChange(e, 'MOON');
        }
      "
      >全选</el-checkbox
    >
    <div style="margin: 10px 0"></div>
    <el-checkbox-group
      v-model="MOON.list"
      class="checkboxGroup"
      @change="handleCheckedCitiesChange"
    >
      <el-checkbox
        v-for="(item, index) in pairMap.MOON"
        :key="index"
        :label="item.pair"
        class="item-one"
        :disabled="item.isOther"
        >{{ item.pair }}</el-checkbox
      >
    </el-checkbox-group>
    <h2 class="subtitle">USDT</h2>
    <el-checkbox
      class="item-one"
      :indeterminate="USDT.isIndeterminate"
      v-model="USDT.checkAll"
      @change="
        (e) => {
          handleCheckAllChange(e, 'USDT');
        }
      "
      >全选</el-checkbox
    >
    <div style="margin: 10px 0"></div>
    <el-checkbox-group
      v-model="USDT.list"
      class="checkboxGroup"
      @change="handleCheckedCitiesChange"
    >
      <el-checkbox
        v-for="(item, index) in pairMap.USDT"
        :key="index"
        :label="item.pair"
        class="item-one"
        :disabled="item.isOther"
        >{{ item.pair }}</el-checkbox
      >
    </el-checkbox-group>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="addOrUpdate">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import api from "./../api";
export default {
  name: "TransactionPair",
  data() {
    return {
      dialogVisible: false,
      parames: {
        pair: [],
      },
      pairMap: {
        BKK: [],
        BTC: [],
        ETH: [],
        MOON: [],
        USDT: [],
      },
      otherDisList: [],
      BKK: {
        list: [],
        isIndeterminate: true,
        checkAll: false,
      },
      BTC: {
        list: [],
        isIndeterminate: true,
        checkAll: false,
      },
      ETH: {
        list: [],
        isIndeterminate: true,
        checkAll: false,
      },
      MOON: {
        list: [],
        isIndeterminate: true,
        checkAll: false,
      },
      USDT: {
        list: [],
        isIndeterminate: false,
        checkAll: false,
      },
    };
  },
  methods: {
    // 初始化开启
    initData(e) {
      this.parames = {
        ...e,
        pair: !e.pair ? [] : JSON.parse(e.pair),
      };

      // 获取禁止交易对
      api.getConfigPair().then((res) => {
        if (res.code === 0) {
          let arry = [];
          res.data.map((item) => {
            if (e.pair) {
              if (!e.pair.includes(item)) {
                arry.push(item);
              }
              this.otherDisList = arry;
            } else {
              this.otherDisList = res.data;
            }
          });
          // 获取全部交易对
          api.getTradePairMap().then((res) => {
            if (res.code === 0) {
              this.pairMap = {
                BKK: res.data.BKK.map((item) => {
                  if (this.otherDisList.includes(item.pair)) {
                    return {
                      ...item,
                      isOther: true,
                    };
                  } else {
                    return {
                      ...item,
                      isOther: false,
                    };
                  }
                }),
                BTC: res.data.BTC.map((item) => {
                  if (this.otherDisList.includes(item.pair)) {
                    return {
                      ...item,
                      isOther: true,
                    };
                  } else {
                    return {
                      ...item,
                      isOther: false,
                    };
                  }
                }),
                ETH: res.data.ETH.map((item) => {
                  if (this.otherDisList.includes(item.pair)) {
                    return {
                      ...item,
                      isOther: true,
                    };
                  } else {
                    return {
                      ...item,
                      isOther: false,
                    };
                  }
                }),
                MOON: res.data.MOON.map((item) => {
                  if (this.otherDisList.includes(item.pair)) {
                    return {
                      ...item,
                      isOther: true,
                    };
                  } else {
                    return {
                      ...item,
                      isOther: false,
                    };
                  }
                }),
                USDT: res.data.USDT.map((item) => {
                  if (this.otherDisList.includes(item.pair)) {
                    return {
                      ...item,
                      isOther: true,
                    };
                  } else {
                    return {
                      ...item,
                      isOther: false,
                    };
                  }
                }),
              };
              // 初始话选中状态
              if (e.pair) {
                this.initChecked(e.pair);
              }
              this.dialogVisible = true;
            }
          });
        }
      });
    },
    // 初始化选中状态
    initChecked(e) {
      const arr = JSON.parse(e);
      arr.map((item) => {
        if (item.indexOf("BKK") > -1) {
          this.BKK.list.push(item);
        }
        if (item.indexOf("BTC") > -1) {
          this.BTC.list.push(item);
        }
        if (item.indexOf("ETH") > -1) {
          this.ETH.list.push(item);
        }
        if (item.indexOf("MOON") > -1) {
          this.MOON.list.push(item);
        }
        if (item.indexOf("USDT") > -1) {
          this.USDT.list.push(item);
        }
      });
      this.handleCheckedCitiesChange();
    },
    // 计算数量
    handleCheckedCitiesChange() {
      this.BKK.checkAll = this.pairMap.BKK.length === this.BKK.list.length;
      this.BKK.isIndeterminate =
        this.BKK.list.length > 0 &&
        this.BKK.list.length < this.pairMap.BKK.length;

      this.BTC.checkAll = this.pairMap.BTC.length === this.BTC.list.length;
      this.BTC.isIndeterminate =
        this.BTC.list.length > 0 &&
        this.BTC.list.length < this.pairMap.BTC.length;

      this.ETH.checkAll = this.pairMap.ETH.length === this.ETH.list.length;
      this.ETH.isIndeterminate =
        this.ETH.list.length > 0 &&
        this.ETH.list.length < this.pairMap.ETH.length;

      this.MOON.checkAll = this.pairMap.MOON.length === this.MOON.list.length;
      this.MOON.isIndeterminate =
        this.MOON.list.length > 0 &&
        this.MOON.list.length < this.pairMap.MOON.length;

      this.USDT.checkAll = this.pairMap.USDT.length === this.USDT.list.length;
      this.USDT.isIndeterminate =
        this.USDT.list.length > 0 &&
        this.USDT.list.length < this.pairMap.USDT.length;
    },
    // 全选
    handleCheckAllChange(e, a) {
      const arry = [];
      if (e) {
        this.pairMap[a].map((item) => {
          if (!item.isOther) {
            arry.push(item.pair);
          }
        });
        this[a].list = arry;
      } else {
        this[a].list = [];
      }
      this[a].isIndeterminate = false;
    },
    // 编辑或者新增
    addOrUpdate() {
      const arry = this.BKK.list.concat(
        this.BTC.list,
        this.ETH.list,
        this.MOON.list,
        this.USDT.list
      );
      api
        .addOrUpdate({
          ...this.parames,
          pair: JSON.stringify(arry),
        })
        .then((res) => {
          if (res.code === 0) {
            this.dialogVisible = false;
            this.$emit("getList");
            this.$message.success("保存成功");
          }
        });
    },
    // 关闭弹窗初始化
    closeDialogVisible() {
      this.parames = {
        pair: [],
      };
      this.pairMap = {
        BKK: [],
        BTC: [],
        ETH: [],
        MOON: [],
        USDT: [],
      };
      this.BKK = {
        list: [],
        disadledList: [],
        isIndeterminate: true,
        checkAll: false,
      };
      this.BTC = {
        list: [],
        disadledList: [],
        isIndeterminate: true,
        checkAll: false,
      };
      this.ETH = {
        list: [],
        disadledList: [],
        isIndeterminate: true,
        checkAll: false,
      };
      this.MOON = {
        list: [],
        disadledList: [],
        isIndeterminate: true,
        checkAll: false,
      };
      this.USDT = {
        list: [],
        disadledList: [],
        isIndeterminate: true,
        checkAll: false,
      };
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
}
.subtitle {
  line-height: 40px;
}
.checkboxGroup {
  margin-bottom: 20px;
}
.page-container {
  .item-one {
    width: 150px;
    margin-left: 30px;
    margin-bottom: 10px;
    overflow: hidden;
  }
  .item {
    width: 150px;
    margin-bottom: 10px;
    overflow: hidden;
  }
}
/deep/.el-dialog__body {
  padding: 10px 20px;
}
</style>
